import type { ThemeNames } from './index'

/**
 * Apply a theme by setting the `data-theme` attribute on the document root.
 * This triggers CSS custom property overrides defined in theme CSS files.
 *
 * Each theme CSS file defines variables under `[data-theme="themeName"]` selectors,
 * while `:root` in default.css provides fallback values.
 */
export function applyTheme(themeName: ThemeNames): void {
  document.documentElement.setAttribute('data-theme', themeName)
  document.documentElement.setAttribute('data-theme-image', themeName)
}

export function getCurrentTheme(): ThemeNames | 'defaultTheme' {
  const theme = document.documentElement.getAttribute('data-theme')
  if (theme === null) {
    return 'defaultTheme'
  }
  return theme as ThemeNames
}
